import { CURSOR_BAR_WIDTH } from "./input-bar-metrics";
import {
  chipGhostFits,
  ghostNaturalRight,
} from "./standalone-bar-ghost-layout";

/** The shell's side padding plus slack around the editable field. */
const FIELD_CHROME = 38;

/** Measure the rendered first line, selected route and complete suggestion.
 * Shared with inert presentations so they grow exactly like the live bar. */
export function standaloneBarContentWidth(
  container: HTMLElement | null,
  value: string,
  widestBar: number,
): number {
  const firstLine = value.split("\n")[0] ?? "";
  let textWidth = firstLine.length * 8;
  const ghost = container?.querySelector<HTMLElement>(
    "[data-standalone-ghost]",
  );
  let ghostTextWidth = 0;
  try {
    const context = document.createElement("canvas").getContext("2d");
    if (context) {
      const field = container?.querySelector<HTMLElement>(
        "[data-testid='standalone-bar-field']",
      );
      context.font =
        (field ? getComputedStyle(field).font : "") || "14px system-ui";
      textWidth = context.measureText(firstLine).width;
      if (ghost)
        ghostTextWidth =
          ghost.offsetLeft +
          context.measureText(ghost.textContent ?? "").width +
          28;
    }
  } catch {
    /* Canvas is unavailable in DOM-only tests. */
  }

  let chipWidth = 0;
  const chip = container?.querySelector<HTMLElement>("[data-standalone-chip]");
  if (chip) {
    const style = getComputedStyle(chip);
    const margins =
      (Number.parseFloat(style.marginLeft) || 0) +
      (Number.parseFloat(style.marginRight) || 0);
    chipWidth = chip.offsetWidth + margins;
    const label = chip.querySelector<HTMLElement>(
      "[data-standalone-chip-label]",
    );
    if (label) chipWidth += Math.max(0, label.scrollWidth - label.clientWidth);
  }
  const ghostRight =
    ghost &&
    (ghost.dataset.standaloneGhost !== "after-chip" ||
      chipGhostFits(ghost, widestBar - FIELD_CHROME - ghost.offsetLeft))
      ? ghostNaturalRight(ghost)
      : 0;
  const needed = Math.max(textWidth + chipWidth, ghostRight, ghostTextWidth);
  return Math.min(CURSOR_BAR_WIDTH, Math.ceil(needed + FIELD_CHROME));
}
